import StepItems from "../../../components/StepItems";
import { FormattedMessage } from "react-intl";

const style = {
	stepsWrapper: `mb-12 lg:mb-0 py-4 lg:basis-1/2`,
	titleWrapper: `mb-8`,
	title: `text-lg tracking-wide text-center text-red lg:text-4xl uppercase aubrey-pro font-bold`,
	afterTitle: `text-xl tracking-wide lg:text-2xl`,
};

const Steps = () => {
	return (
		<div className={style.stepsWrapper}>
			<div className={style.titleWrapper}>
				<h2 className={style.title}>
					<FormattedMessage id='step.title' />
				</h2>
			</div>
			<StepItems />
		</div>
	);
};

export default Steps;
